import moment from 'moment-jalaali';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const initialState = {
  filters: {
    origin: { label: 'گرمسار', value: '5e3dbf566b09850543a67a9a' },
    destination: null,
    fleetOptions: [],
    fromDate: moment().subtract(3, 'months'),
    toDate: moment(),
    progress: false,
    isPreviuseOrders: true,
  },
  basePrice: {
    previusePage: 1,
    page: 1,
    previuseOrders: { previuseOrdersAvgPrice: 0 },
    orders: {
      orders: null,
      averagePrice: 0,
      basePriceAverage: 0,
      totalAverage: 0,
    },
  },
};
export const useCalculation = create(
  immer((set, get) => ({
    ...initialState,
    changePreviusePage: (payload) =>
      set((state) => {
        state.basePrice.previusePage = payload;
      }),
    changePage: (payload) =>
      set((state) => {
        state.basePrice.page = payload;
      }),
    setOrigin: (payload) =>
      set((state) => {
        state.filters.origin = payload;
      }),
    setDestination: (payload) =>
      set((state) => {
        state.filters.destination = payload;
      }),
    setFleetOptions: (payload) =>
      set((state) => {
        state.filters.fleetOptions = payload;
      }),
    setFromDate: (payload) =>
      set((state) => {
        state.filters.fromDate = payload;
      }),
    setToDate: (payload) =>
      set((state) => {
        state.filters.toDate = payload;
      }),
    setProgress: (payload) =>
      set((state) => {
        state.filters.progress = payload;
      }),
    setIsPreviuseOrder: (payload) =>
      set((state) => {
        state.filters.isPreviuseOrders = payload;
      }),
    setOrders: (payload) =>
      set((state) => {
        state.basePrice.orders = {
          orders: payload?.orders,
          averagePrice: payload?.averagePrice || 0,
          basePriceAverage: payload?.basePriceAverage || 0,
          totalAverage: payload?.totalAverage || 0,
        };
      }),
    setPreviuseOrders: (payload) =>
      set((state) => {
        state.basePrice.previuseOrders = payload.basePrices;
      }),
    setPreviuseOrdersAvgPrice: (payload) =>
      set((state) => {
        state.basePrice.previuseOrders.previuseOrdersAvgPrice = payload;
      }),
    reset: () =>
      set((state) => {
        state.filters = initialState.filters;
        state.basePrice = initialState.basePrice;
      }),
  }))
);
